import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import Grid from '../components/common/grid'
import FAQItem from '../components/common/faq'

const Howtolink = props => {
  const wp = props.data.wordpressPage.acf

  return (
    <Layout>
      <div className="qa-section">
        <div className="qa-section__inner">
          <Grid
            items={wp.faq}
            template={props => (
              <>
                <div className="qa-section__title">{props.faq_heading}</div>
                <div className="qa-section__items">
                  <Grid
                    items={props.other_faq}
                    template={qa => (
                      <FAQItem question={qa.question} answer={qa.answer} />
                    )}
                  />
                </div>
              </>
            )}
          />
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query FAQPage(
    $id: wordpressPageIdQueryString_2 = {
      eq: "c0172539-53e9-5aa7-add0-6495b0fa5410"
    }
  ) {
    wordpressPage(id: $id) {
      acf {
        faq {
          faq_heading
          other_faq {
            question
            answer
          }
        }
      }
    }
  }
`
export default Howtolink
